<template>
  <div class="blacklist-custom-content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><svg-icon icon-class="blacklist" /> Custom Blacklist </span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="createCustomBlacklist"
          ><i class="el-icon-plus"></i> Add Blacklist</el-button
        >
      </div>
      <div>

        <div>
          <el-table
            v-loading="loading"
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column label="Member Code" prop="memberCode" width="120" align="center">
            </el-table-column>
            <el-table-column label="Name" prop="name" min-width="200">
            </el-table-column>
            <el-table-column
              label="Exactly Match"
              prop="exactlyMatch"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag :type="`${!scope.row.exactlyMatch ? 'info' : ''}`">
                  {{ scope.row.exactlyMatch ? "Yes" : "No" }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              label="Action"
              prop="uid"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="warning"
                  size="mini"
                  @click="editBlacklist(scope.row.uid, scope.row.plusuid)"
                >
                  Edit
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteBlacklist(scope.row.uid, scope.row.plusuid, scope.row.name)"
                >
                  Del
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 16px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 30, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="recordTotal">
            </el-pagination>
          </div>
      </div>
    </el-card>

    <el-dialog
      :title="titleDialog"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="formDataRules"
        label-width="120px"
        size="mini"
        
      >

        <el-form-item label="Membercode" v-if="actionDialog==='add'">
          <el-input v-model="customer.uid1" @input="searchChange" placeholder="Search by Member code">
            ><el-button
              type="primary"
              icon="el-icon-search"
              slot="append"
              :loading="searchLoading"
              @click="searchCustomer"
              >Search</el-button
            ></el-input
          >
          <el-alert
            v-if="customer.uid2"
            title="This member can create blacklist"
            :description="`Plus UID is ${customer.uid2}`"
            type="success"
            show-icon
            :closable="false"
          >
          </el-alert>
         
        </el-form-item>
        <el-form-item label="Name" prop="name" v-if="customer.uid2">
          <el-input v-model="formData.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Exactly Match" v-if="customer.uid2">
          <el-select v-model="formData.exactlyMatch">
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="customer.uid2">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitBlacklist" :loading="submitting"
          >Submit</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchCustomBlacklist,
  getCustomBlacklist,
  getCustomProjectBlacklist,
  createCustomBlacklist,
  getCustomBlacklistByUID,
  putCustomBlacklistByUID,
  deleteCustomBlacklistByUID,
} from "@/api/firewall-blacklist";
export default {
  props:{
    projectUID: String,
    companyUID: String
  },
  data() {
    return {
      loading: false,
      searchLoading: false,
      submitting: false,
      dialogFormVisible: false,
      actionDialog: "add",
      enterTimeout: null,
      editUID: "",
      customer: {
        uid1: "",
        uid2: "",
      },
      titleDialog: "Create Custom Blacklist",
      
      tableData: [],
      formData: {
        name: "",
        exactlyMatch: false,
      },
      formDataRules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
      },
      query: {
        start: 0,
        length: this.pageSize,
        order: "DESC"
      },
      recordTotal: 0,
      pageSize: 10,
      currentPage: 1
    };
  },
  methods: {
    searchChange(){
      if (this.enterTimeout) clearTimeout(this.enterTimeout);
      this.enterTimeout = setTimeout(() => {
        this.searchCustomer();
      }, 800);
    },
    searchCustomer(){
      this.searchLoading = true;
      searchCustomBlacklist({uid1: this.customer.uid1}).then(({result, data})=>{
        this.searchLoading = false;
        if(result){
           this.customer.uid1 = data.customer.uid1
           this.customer.uid2 = data.customer.uid2
           
        }
      })
    },
    getBlacklist() {
      this.query.start = (this.currentPage * this.pageSize) - (this.pageSize + 1)
      if(this.query.start < 0) this.query.start = 0
      this.query.length = this.pageSize
      this.loading = true;
      
      getCustomProjectBlacklist(this.query, this.projectUID).then(({ result, data }) => {
        this.loading = false;
        if (result && data) {
          this.tableData = data.data
          this.recordTotal = data.recordsTotal
          
        }
      });
    },
    createCustomBlacklist() {
      this.resetForm();
      this.dialogFormVisible = true;
      this.actionDialog = "add";
      this.titleDialog = "Create Custom Blacklist";
    },
    submitBlacklist() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (this.actionDialog === "add") {
            createCustomBlacklist(this.customer.uid2, this.formData).then(({ result, message }) => {
              this.submitting = false;
              if (result) {
                this.dialogFormVisible = false;
                this.getBlacklist();
                this.resetForm();
              } else {
                this.$message.error(message);
              }
            });
          } else {
            putCustomBlacklistByUID(this.customer.uid2, this.editUID, this.formData).then(
              ({ result, message }) => {
                this.submitting = false;
                if (result) {
                  this.dialogFormVisible = false;
                  this.editUID = "";
                  this.getBlacklist();
                  this.resetForm();
                } else {
                  this.$message.error(message);
                }
              }
            );
          }
        }
      });
    },
    editBlacklist(uid, plusuid) {
      this.loading = true;
      this.editUID = uid;
      this.titleDialog = "Edit Custom Blacklist";
      getCustomBlacklistByUID(plusuid, uid).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.customer.uid2 = data.plusuid;
          this.formData.name = data.name;
          this.formData.exactlyMatch = data.exactlyMatch ? true : false;
          this.actionDialog = "edit";
          this.dialogFormVisible = true;
        }
      });
    },
    deleteBlacklist(uid, plusuid, name) {
      this.$confirm(`This will delete ${name} . Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          deleteCustomBlacklistByUID(plusuid, uid).then(({ result, message }) => {
            this.loading = false;
            if (result) {
              this.getBlacklist();
            } else {
              this.$message.error(message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    resetForm() {
      this.formData.name = "";
      this.formData.exactlyMatch = false;
      this.customer.uid1 = "";
      this.customer.uid2 = "";
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getBlacklist()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getBlacklist()
    }
  },
  mounted() {
    this.getBlacklist()
  },
};
</script>

<style lang="scss">
.blacklist-custom-content {
  padding: 0;
}
</style>